import { CopyCommand } from "./copy-command";
import type { PracticeLabStepStateResponse } from "@/types/practice-lab";

// Submission runs from the member's machine (the review needs their actual
// code, which only the terminal has) — so there is no web submit button.
// We just show the `lab submit` command; the review streams back into the
// snapshot over SSE once the CLI submits.
export function LabControls({
  state,
}: {
  state: PracticeLabStepStateResponse | null;
}) {
  const reviewsLeft = state?.reviews_left ?? 0;
  const submissionsUsed = state?.submissions_used ?? 0;
  const limit = reviewsLeft + submissionsUsed;
  const submittable = state?.submittable ?? false;

  // No attempts left (or the step is already terminal) — nothing to prompt.
  if (reviewsLeft <= 0) return null;

  return (
    <div className="space-y-3 rounded-lg border bg-muted/40 p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-medium">
          {submittable ? "Ready for review" : "Submit for review"}
        </p>
        <span className="text-sm text-muted-foreground">
          <span className="font-medium text-foreground">
            {reviewsLeft}/{limit || 3}
          </span>{" "}
          review attempts left
        </span>
      </div>
      <p className="text-sm text-muted-foreground">
        {submittable
          ? "Your checks are green. Run this in your terminal — the review appears here live."
          : "When this step's checks pass, run this in your terminal to submit for review."}
      </p>
      <CopyCommand cmd="lab submit" />
    </div>
  );
}
